/* schoolOptions interleaves school group headers with the schools that belong to
 * them, and a group can share its name with one of its schools. Always go through
 * these helpers so a header is never mistaken for a school.
 */
export function excludeGroupHeaders(schoolOptions) {
  return schoolOptions.filter((schoolOption) => !schoolOption.isGroupHeader);
}

export function findSchoolByName(schoolOptions, name) {
  return excludeGroupHeaders(schoolOptions).find((school) => school.name === name);
}

export function getUniqueSchoolsSortedByName(schoolOptions) {
  const seenNames = [];

  return excludeGroupHeaders(schoolOptions)
    .filter((school) => {
      if (seenNames.includes(school.name)) return false;
      seenNames.push(school.name);
      return true;
    })
    .sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
}

/* Takes a string and an object we want to search. Searches the keys for the
 * string and returns the keys which contain the string
 */
export function searchStringInObjectKeys(needle, haystack) {
  needle = needle.toLowerCase();
  let results = {};
  for (let key in haystack) {
    if (haystack.hasOwnProperty(key)) {
      if (key.toLowerCase().indexOf(needle) !== -1) {
        results[key] = haystack[key];
      }
    }
  }
  return results;
}
